import mock from '@/@fake-db/mock'
import { paginateArray, sortCompare } from '@/@fake-db/utils'

/* eslint-disable global-require */
const data = {
  users: [
    {
      id: 1,
      username: 'gslixby0',
      employeeId: 'gslixby0',
      titleName: 'Ms.',
      firstName: 'Galen',
      lastName: 'Slixby',
      permissionGroup: 'director',
      status: 'inactive',
      avatar: require('@/assets/images/avatars/7.png'),
      password: 'test',
      idCardNumber: '1234567890123',
      gender: 'female',
      nickname: 'Gale',
      bankAccountNumber: '1017771000',
      bankAccountName: 'Miss Galen Slixby',
      bankName: 'bbl',
      bankBranchName: 'Head Office',
      mobile: '(66) 909225000',
      email: 'gslixby0@abc.net.au',
      addressDetail: 'Russia',
      subDistrict: '',
      district: '',
      province: '',
      zipCode: '',
      addressInformation: [
        {
          mobile: '(479) 232-9151',
          email: 'gslixby0@abc.net.au',
          subDistrict: '',
          district: '',
          province: '',
          zipCode: '',
          addressDetail: 'Russia',
          status: 'inactive',
        },
        {
          mobile: '(66) 909225000',
          email: 'gslixby0@abc.net.au',
          subDistrict: '',
          district: '',
          province: 'Bankok',
          zipCode: '',
          addressDetail: 'Thailand',
          status: 'active',
        },
      ],
      orders: [
        {
          orderNumber: 1,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
        {
          orderNumber: 2,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
        {
          orderNumber: 3,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
      ],
    },
    {
      id: 2,
      username: 'hredmore1',
      employeeId: 'hredmore1',
      titleName: 'Mr.',
      firstName: 'Halsey',
      lastName: 'Redmore',
      permissionGroup: 'manager',
      status: 'pending',
      avatar: require('@/assets/images/avatars/10.png'),
      password: '55555',
      idCardNumber: '2200022000222',
      gender: 'male',
      nickname: 'Hal',
      bankAccountNumber: '',
      bankAccountName: '',
      bankName: '',
      bankBranchName: '',
      mobile: '(472) 607-9137',
      email: 'hredmore1@imgur.com',
      addressDetail: 'China',
      subDistrict: '',
      district: '',
      province: '',
      zipCode: '',
      addressInformation: [
        {
          mobile: '(472) 607-9137',
          email: 'hredmore1@imgur.com',
          subDistrict: '',
          district: '',
          province: '',
          zipCode: '',
          addressDetail: '',
          status: 'inactive',
        },
        {
          mobile: '(472) 607-9137',
          email: 'hredmore1@imgur.com',
          subDistrict: '',
          district: '',
          province: '',
          zipCode: '',
          addressDetail: '',
          status: 'active',
        },
      ],
      orders: [
        {
          orderNumber: 1,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
        {
          orderNumber: 2,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
        {
          orderNumber: 3,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
      ],
    },
    {
      id: 3,
      username: 'msicely2',
      employeeId: 'msicely2',
      titleName: 'Ms.',
      firstName: 'Marjory',
      lastName: 'Sicely',
      permissionGroup: 'sales',
      status: 'active',
      avatar: require('@/assets/images/avatars/1.png'),
      password: 'asdf',
      idCardNumber: '1000010000100',
      gender: 'male',
      nickname: 'Mar',
      bankAccountNumber: '',
      bankAccountName: '',
      bankName: '',
      bankBranchName: '',
      mobile: '(321) 264-4599',
      email: 'msicely2@who.int',
      addressDetail: 'Canada',
      subDistrict: '',
      district: '',
      province: '',
      zipCode: '',
      addressInformation: [
        {
          mobile: '(321) 264-4599',
          email: 'msicely2@who.int',
          subDistrict: '',
          district: '',
          province: '',
          zipCode: '',
          addressDetail: '',
          status: 'inactive',
        },
        {
          mobile: '(321) 264-4599',
          email: 'msicely2@who.int',
          subDistrict: '',
          district: '',
          province: '',
          zipCode: '',
          addressDetail: '',
          status: 'active',
        },
      ],
      orders: [
        {
          orderNumber: 1,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
        {
          orderNumber: 2,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
        {
          orderNumber: 3,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
      ],
    },
    {
      id: 4,
      username: 'crisby3',
      employeeId: 'crisby3',
      titleName: 'Ms.',
      firstName: 'Cyrill',
      lastName: 'Risby',
      permissionGroup: 'marketing',
      status: 'inactive',
      avatar: require('@/assets/images/avatars/9.png'),
      password: '4321',
      idCardNumber: '3300000000333',
      gender: 'female',
      nickname: 'Cy',
      bankAccountNumber: '',
      bankAccountName: '',
      bankName: '',
      bankBranchName: '',
      mobile: '(923) 690-6806',
      email: 'crisby3@wordpress.com',
      addressDetail: 'United States',
      subDistrict: '',
      district: '',
      province: '',
      zipCode: '',
      addressInformation: [
        {
          mobile: '(923) 690-6806',
          email: 'crisby3@wordpress.com',
          subDistrict: '',
          district: '',
          province: '',
          zipCode: '',
          addressDetail: '',
          status: 'inactive',
        },
        {
          mobile: '(923) 690-6806',
          email: 'crisby3@wordpress.com',
          subDistrict: '',
          district: '',
          province: '',
          zipCode: '',
          addressDetail: '',
          status: 'active',
        },
      ],
      orders: [
        {
          orderNumber: 1,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
        {
          orderNumber: 2,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
        {
          orderNumber: 3,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
      ],
    },
    {
      id: 5,
      username: 'mhurran4',
      employeeId: 'mhurran4',
      titleName: 'Mr.',
      firstName: 'Maggy',
      lastName: 'Hurran',
      permissionGroup: 'finance',
      status: 'pending',
      avatar: require('@/assets/images/avatars/2.png'),
      password: 'abcd1234',
      idCardNumber: '9090900000000',
      gender: 'male',
      nickname: 'Mag',
      bankAccountNumber: '',
      bankAccountName: '',
      bankName: '',
      bankBranchName: '',
      mobile: '(669) 914-1078',
      email: 'mhurran4@yahoo.co.jp',
      addressDetail: 'United States',
      subDistrict: '',
      district: '',
      province: '',
      zipCode: '',
      addressInformation: [
        {
          mobile: '(669) 914-1078',
          email: 'mhurran4@yahoo.co.jp',
          addressDetail: 'Thailand',
          subDistrict: '',
          district: '',
          province: '',
          zipCode: '',
          status: 'inactive',
        },
        {
          mobile: '(669) 914-1078',
          email: 'mhurran4@yahoo.co.jp',
          subDistrict: '',
          district: '',
          province: '',
          zipCode: '',
          addressDetail: 'United States',
          status: 'active',
        },
      ],
      orders: [
        {
          orderNumber: 1,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
        {
          orderNumber: 2,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
        {
          orderNumber: 3,
          orderStatus: 'Order Status : Place Order',
          orderDate: '',
          total: 0,
          status: 'active',
        },
      ],
    },
  ],
}
/* eslint-enable */

// ------------------------------------------------
// GET: Return Users
// ------------------------------------------------
mock.onGet('/apps/user/users').reply(config => {
  // eslint-disable-next-line object-curly-newline
  const {
    q = '',
    perPage = 10,
    page = 1,
    sortBy = 'id',
    sortDesc = false,
    permissionGroup = null,
    status = null,
  } = config.params
  /* eslint-enable */

  const queryLowered = q.toLowerCase()
  const filteredData = data.users.filter(
    user =>
      /* eslint-disable operator-linebreak, implicit-arrow-linebreak */
      (user.employeeId.toLowerCase().includes(queryLowered) || user.titleName.toLowerCase().includes(queryLowered) ||
       user.firstName.toLowerCase().includes(queryLowered) || user.lastName.toLowerCase().includes(queryLowered) ||
       user.mobile.toLowerCase().includes(queryLowered) || user.email.toLowerCase().includes(queryLowered) ||
       user.permissionGroup.toLowerCase().includes(queryLowered) || user.status.toLowerCase().includes(queryLowered)) &&
      user.permissionGroup === (permissionGroup || user.permissionGroup) &&
      user.status === (status || user.status),
  )
  /* eslint-enable  */

  const sortedData = filteredData.sort(sortCompare(sortBy))
  if (sortDesc) sortedData.reverse()

  return [
    200,
    {
      users: paginateArray(sortedData, perPage, page),
      total: filteredData.length,
    },
  ]
})

// ------------------------------------------------
// POST: Add new user
// ------------------------------------------------
mock.onPost('/apps/user/users').reply(config => {
  // Get event from post data
  const { user } = JSON.parse(config.data)

  // Assign Status
  user.status = 'active'

  const { length } = data.users
  let lastIndex = 0
  if (length) {
    lastIndex = data.users[length - 1].id
  }
  user.id = lastIndex + 1

  data.users.push(user)

  return [201, { user }]
})

// ------------------------------------------------
// GET: Return Single User
// ------------------------------------------------
mock.onGet(/\/apps\/user\/users\/\d+/).reply(config => {
  // Get event id from URL
  let userId = config.url.substring(config.url.lastIndexOf('/') + 1)

  // Convert Id to number
  userId = Number(userId)

  const userIndex = data.users.findIndex(e => e.id === userId)
  const user = data.users[userIndex]

  if (user) return [200, user]
  return [404]
})
